import React from "react"
import { enter } from "../../../utils"

export interface ChatButtonBodyProps {
    displayEnter: boolean,
    regenerateResponse: () => void,
    btnText: string,
    additionalStyle?: React.CSSProperties
}
export const ChatButtonBody:React.FC<ChatButtonBodyProps> = ({displayEnter, regenerateResponse, btnText, additionalStyle}) => {
    return <section className="ErrorBtn" style={additionalStyle}>
        <article className="ErrorBtn__title" onClick={regenerateResponse}>
            <span>{btnText}</span>
        </article>
        {displayEnter ? <article className="ErrorBtn__text">
            <p>press</p>
            <p className="ErrorBtn__text__boldPart">Enter</p>
            <img src={enter} alt="enter" className="ErrorBtn__text__img"/>
        </article> : null}
    </section>
}